// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1-X-r","alertIcon":"ConfirmModal_alertIcon__1E7yF"};